import { ReducerRegistry } from 'store';
import {
  ACCOUNT_FETCH,
  ACCOUNT_FETCH_ASYNC_START,
  ACCOUNT_UPDATE,
  ACCOUNT_UPDATE_ASYNC_START,
} from '../types';

const INITIAL_STATE = {
  isLoading: false,
  inProgress: false,
  details: {},
  transactions: [],
};

export const commonReducer = ReducerRegistry.register(
  'cashout',
  (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case ACCOUNT_FETCH_ASYNC_START:
        return { ...state, inProgress: true };
      case ACCOUNT_FETCH:
        return { ...state, inProgress: false, details: action?.payload };
      case ACCOUNT_UPDATE_ASYNC_START:
        return { ...state, inProgress: true };
      case ACCOUNT_UPDATE:
      default:
        return state;
    }
  },
);
